import Paper from '@mui/material/Paper';
import { t } from 'i18next';
import { List, Map } from 'immutable';
import React from 'react';

import { API_DOMAIN } from '@sophocles/config';
import TextTR from '@sophocles/views/returns/components/TextTR';

class InvoiceSummaryPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { rma } = this.props;

    const customer = rma.getIn(['site_group', 'customer'], Map());
    const isBillboard = customer ? customer.get('is_billboard', true) : true;
    const siteGroup = rma.get('site_group', Map());
    const site = rma.get('site', null);

    const rmaNumber = rma.get('rma_number', null);
    // show the legacy fields if they exist.
    const legacyOldIccid = rma.get('legacy_incoming_iccid', null);
    const legacyReplacedIccid = rma.get('legacy_replaced_iccid', null);

    const contact = rma.get('contact', Map());
    const contactName = contact ? contact.get('name', null) : null;
    const contactTitle = contact ? contact.get('title', null) : null;
    const contactEmail = contact ? contact.get('email', null) : null;

    const oldICCID = rma.getIn(['radio_returned_by_user', 'iccid'], '');
    const newICCID = rma.getIn(['radio_shipped_to_user', 'iccid'], '');

    const warrantyStatus = rma.getIn(['warranty_status', 'name'], null);

    const issueSubCategory = rma.get('issue', null);
    const issueCategory = issueSubCategory ? issueSubCategory.get('category', null) : null;

    const comments = rma.get('comments', '');

    const trackingNumber = rma.get('tracking_number', '');

    const shippingCost = Number(rma.get('shipping_cost', 0));
    const handlingCost = Number(rma.get('handling_cost', 0));

    const shippingAndHandlingCost = Number(shippingCost + handlingCost).toFixed(2);

    const unauthorizedSwap = rma.get('unauthorized_swap', false);

    const warrantyFee = rma.get('warranty_fee', null);
    const additionalFees = rma.get('additional_fees', List());

    const billingAddress = rma.get('billing_address', false) ? rma.get('billing_address') : Map();

    const additionalFeeDisplay =
      additionalFees.size > 0 ? (
        <ul style={{ margin: 0, listStyle: 'none', padding: 0 }}>
          {additionalFees.map((fee, index) => (
            <li key={index}>{fee.get('reason', '')}</li>
          ))}
        </ul>
      ) : (
        <div>{t('rma.noExtraFees', 'No Extra Fees')}</div>
      );

    const outboundShippingMode = rma.getIn(['outbound_shipping_mode', 'name'], t('rma.noneLower', 'none'));

    const tableDisplay = (
      <table style={{ lineHeight: '14px', fontSize: '12px' }}>
        <tbody>
          <TextTR title={t('rma.customerLabel', 'Customer')}>{customer.get('name', t('rma.noneLower', 'none'))}</TextTR>
          <TextTR title={isBillboard ? t('rma.plant', 'Plant') : t('rma.siteGroupLabel', 'Site Group')}>
            {siteGroup.get('name', '0')} - {siteGroup.get('description', t('rma.noneLower', 'none'))}
          </TextTR>
          <TextTR title={t('rma.contactLabel', 'Contact')}>{contactName}</TextTR>
          <TextTR title={t('rma.contactTitle', 'Contact Title')} show={!!contactTitle}>
            {contactTitle}
          </TextTR>
          <TextTR title={t('rma.contactEmail', 'Contact Email')} show={!!contactEmail}>
            {contactEmail}
          </TextTR>
          <TextTR title={t('rma.oldDeviceIccid', 'Old Device ICCID')}>{oldICCID || legacyOldIccid}</TextTR>
          <TextTR title={t('rma.replacementIccid', 'Replacement ICCID')}>{newICCID || legacyReplacedIccid}</TextTR>

          <TextTR title={isBillboard ? t('rma.structure', 'Structure') : t('rma.siteLabel', 'Site')}>
            {site
              ? `${site.get('name', '0')} - ${site.get('description', t('rma.noneLower', 'none'))}`
              : t('rma.noneListed', 'None Listed')}
          </TextTR>

          <TextTR title={t('rma.issueCategory', 'Category')}>{issueCategory.get('name', '')}</TextTR>
          <TextTR title={t('rma.issueSubCategory', 'Subcategory')}>{issueSubCategory.get('name', '')}</TextTR>

          <TextTR title={t('rma.authorizedSwapOut', 'Authorized Swap Out')}>
            {unauthorizedSwap ? t('general.no', 'No') : t('general.yes', 'Yes')}
          </TextTR>
          <TextTR title={t('rma.warrantyStatus', 'Warranty')}>
            {warrantyStatus || t('rma.noneSelected', 'None selected')}
          </TextTR>
          <TextTR title={t('rma.resolution', 'Resolution')}>{comments}</TextTR>

          <tr>
            <td>
              <div>&nbsp;</div>
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: '18px', fontWeight: 'bold' }}>
              {t('rma.billingInformation', 'Billing Information:')}
            </td>
          </tr>
          <TextTR title={t('general.name', 'Name')}> {billingAddress.get('name', '')} </TextTR>
          <TextTR title={t('general.phone', 'Phone')}> {billingAddress.get('', '')}</TextTR>
          <TextTR title={t('rma.address', 'Address')}> {billingAddress.get('address_line_1', '')}</TextTR>
          <TextTR title={t('rma.address', 'Address')} show={billingAddress.get('address_line_2', '') != ''}>
            {' '}
            {billingAddress.get('address_line_2', '')}
          </TextTR>
          <TextTR title={t('rma.address', 'Address')} show={billingAddress.get('address_line_3', '') != ''}>
            {' '}
            {billingAddress.get('address_line_3', '')}
          </TextTR>
          <TextTR title={t('rma.city', 'City')}> {billingAddress.get('city', '')}</TextTR>
          <TextTR title={t('rma.state', 'State')}> {billingAddress.get('state', '')}</TextTR>
          <TextTR title={t('rma.zip', 'Zip')}>{billingAddress.get('postal_code', '')} </TextTR>
          <TextTR title={t('rma.country', 'Country')}>{billingAddress.get('country', '')} </TextTR>
          <tr>
            <td>
              <div>&nbsp;</div>
            </td>
          </tr>
          <TextTR title={t('rma.trackingHash', 'Tracking #')}> {trackingNumber} </TextTR>
          <TextTR title={t('rma.shippingHandlingCostLabel', 'Shipping & Handling Cost')}>
            {' '}
            {shippingCost ? '$' + shippingAndHandlingCost : ''}
          </TextTR>
          <TextTR title={t('rma.instructions', 'Instructions')}> {outboundShippingMode}</TextTR>
          <TextTR title={t('rma.warrantyFee', 'Warranty Fee')}>
            {warrantyFee ? `${warrantyFee.get('reason', '')}` : ''}
            {/* - $${warrantyFee.get('fee')}` : 'None' */}
          </TextTR>
          <TextTR title={t('rma.additionalFees', 'Additional Fees')}>{additionalFeeDisplay}</TextTR>
        </tbody>
      </table>
    );

    return (
      <div>
        <Paper style={{ padding: '24px' }}>
          <div style={{ textAlign: 'center' }}>
            <h4>{t('rma.invoiceForRma', 'Invoice for RMA # {{num}}', { num: rmaNumber })}</h4>
          </div>
          {tableDisplay}
          <div style={{ textAlign: 'center', paddingTop: '8px' }}>
            <img src={`${API_DOMAIN}/static/pliny/png/odl_logo_2017.png`} height="40" alt="" />
          </div>
        </Paper>
      </div>
    );
  }
}

export default InvoiceSummaryPage;
